const actions = {
  LOAD_MEDICAL_INSTITUTIONS: "LOAD_MEDICAL_INSTITUTIONS",

  LOAD_SUBORDINATE_INSTITUTIONS: "LOAD_SUBORDINATE_INSTITUTIONS",
  SUBORDINATE_INSTITUTIONS_IS_LOADING: "SUBORDINATE_INSTITUTIONS_IS_LOADING",

  LOAD_ALL_TYPES: "LOAD_ALL_TYPES",
  ALL_TYPES_ARE_LOADING: 'ALL_TYPES_ARE_LOADING',

  LOAD_INSTITUTION_DETAIL: "LOAD_INSTITUTION_DETAIL",
  LOAD_INSTITUTION_PERSONAL: "LOAD_INSTITUTION_PERSONAL",
  LOAD_INSTITUTION_PERSONAL_DETAIL: "LOAD_INSTITUTION_PERSONAL_DETAIL",
  LOAD_INSTITUTION_SERVICES: "LOAD_INSTITUTION_SERVICES",
  LOAD_INSTITUTION_SERVICE_DETAIL: "LOAD_INSTITUTION_SERVICE_DETAIL",
  INSTITUTIONS_IS_LOADED: "INSTITUTIONS_IS_LOADED",
  INSTITUTIONS_IS_LOADING: "INSTITUTIONS_IS_LOADING",
  SUBORDINATE_IS_LOADING: "SUBORDINATE_IS_LOADING",
  LOAD_ACCOSTS: "LOAD_ACCOSTS",
  LOAD_ACCOST_DETAIL: "LOAD_ACCOST_DETAIL",
  SET_ACCOST_ITEM: "SET_ACCOST_ITEM",
  SET_ACCOST_ITEM_VALUE: "SET_ACCOST_ITEM_VALUE",
  LOAD_RATING: "LOAD_RATING",
  LOAD_RATING_DETAIL: "LOAD_RATING_DETAIL",
  CHECK_RATING: "CHECK_RATING",
  LOAD_PROFESSION_CLASSIFICATION: "LOAD_PROFESSION_CLASSIFICATION",
  LOAD_CURRENT_USER_INSTITUTIONS: "LOAD_CURRENT_USER_INSTITUTIONS",
  CLEAN_CURRENT_USER_INSTITUTIONS: "CLEAN_CURRENT_USER_INSTITUTIONS",
  CURRENT_USER_INSTITUTIONS_IS_LOADING: "CURRENT_USER_INSTITUTIONS_IS_LOADING",
  CHANGE_RATING_COMMENT: "CHANGE_RATING_COMMENT",
  CLEAN_INSTITUTION_PERSONAL_DETAIL: "CLEAN_INSTITUTION_PERSONAL_DETAIL",
  CLEAN_INSTITUTION_SERVICE_DETAIL: "CLEAN_INSTITUTION_SERVICE_DETAIL",

  LOAD_INSTITUTION_PARENT: "LOAD_INSTITUTION_PARENT"
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/constants/portal/institutions.js